import {
  Channel,
  DialogType,
  SessionUpdateInterval,
  Topic
} from "../../../constants/index";
import { MessageBrokerUtils, AppFeatureUtils } from "../../../utils";
import {
  call,
  cancel,
  cancelled,
  delay,
  fork,
  put,
  select,
  take,
  takeEvery
} from "redux-saga/effects";

import { Brand } from "../../../configurations";
import { UserContextActionConstants } from "../../action-constants";
import { UserContextActionCreators } from "../../action-creators";
import { UserContextApi } from "../../api";
import {
  RealityCheckSelectors,
  UserContextSelectors
} from "../../../redux/selectors";
import { BrandUtils } from "../../../utils/brandUtils";
import { DeviceUtils } from "../../../utils/deviceUtils";
import { AppFeatures } from "../../../constants/featureFlags";

const { STOP_SESSION_TIME_TASK, START_SESSION_TIME_TASK } =
  UserContextActionConstants;

const {
  sessionTimeTaskStopped,
  getSessionTimeError,
  getSessionTime,
  getSessionTimeFulfilled
} = UserContextActionCreators;

function* startSessionTimeTask() {
  const bgSyncTask = yield fork(sessionTimeInterval);
  yield take(STOP_SESSION_TIME_TASK);
  yield cancel(bgSyncTask);
}

function* sessionTimeInterval() {
  try {
    while (true) {
      yield call(getSessionTimeFromApi);
      yield delay(SessionUpdateInterval);
    }
  } finally {
    if (yield cancelled()) yield put(sessionTimeTaskStopped());
  }
}

function* getSessionTimeFromApi() {
  yield put(getSessionTime());
  const { sessionActivationTime } = yield select(
    RealityCheckSelectors.sportSessionDetails
  );
  const { response, errorResponse } = yield call(
    UserContextApi.getSessionTime,
    sessionActivationTime
  );
  const brand = yield select(UserContextSelectors.brandId);
  const timeSpentReminderEnabled = AppFeatureUtils.findIfIsInFeature(
    AppFeatures.TIME_SPENT_REMINDER
  );

  const isSiP = DeviceUtils.isPokerApp();
  const isFullDetailsBrand =
    brand === Brand.Sport_Com || brand === Brand.Sport_MG_MGA;

  if (response) {
    yield put(getSessionTimeFulfilled(response.SessionTime));

    if (!!response.RealityCheck) {
      if (timeSpentReminderEnabled) {
        if (isSiP) return;

        const showWinLossStatement =
          !BrandUtils.isPokerClient() &&
          [
            Brand.Sport_Com,
            Brand.Sport_RO,
            Brand.Sport_DE,
            Brand.Sport_MG_MGA
          ].includes(brand); // brands to display

        const showWageredAmount = isFullDetailsBrand;
        const showContentTitle = isFullDetailsBrand;

        const hideDisclaimer = [
          Brand.Sport_MG_SE,
          Brand.Sport_MG_DK,
          Brand.Sport_SE,
          Brand.Sport_DE,
          Brand.Sport_MG_MGA
        ].some(b => b === brand);

        const funcProps = [
          {
            channel: Channel.UI,
            topic: Topic.Dialog,
            headers: {
              publisher: "UAA"
            },
            data: {
              dialogType: DialogType.TimeSpentReminder,
              options: {
                showContentTitle,
                loggedInTime: response.SessionTime,
                winLossStatement: response.NetLossAmount,
                wagerAmount: response.WagerAmount,
                showWinLossStatement,
                showWageredAmount,
                hideDisclaimer
              }
            }
          }
        ];
        yield call(MessageBrokerUtils.publish, ...funcProps);
      } else {
        const publishProps = [
          {
            channel: Channel.UI,
            topic: Topic.Dialog,
            headers: {
              publisher: "UAA"
            },
            data: {
              dialogType: DialogType.RealityCheck,
              options: {
                loggedInTime: response.SessionTime,
                winLossStatement: response.NetLossAmount
              }
            }
          }
        ];

        yield call(MessageBrokerUtils.publish, ...publishProps);
      }
    }
  } else if (errorResponse) {
    yield put(getSessionTimeError(errorResponse));
  }
}

export default [takeEvery(START_SESSION_TIME_TASK, startSessionTimeTask)];
